import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink, Container
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { router } from "routes";
import { Breadcrumb as BreadcrumbType } from "types/Breadcrumb";


type MyBreadcrumbProps = {
  breadcrumb?: BreadcrumbType
}

/**
 * A functional component that renders a breadcrumb navigation.
 *
 * @component
 * @param {MyBreadcrumbProps} props - The properties for the MyBreadcrumb component.
 * @param {BreadcrumbType} [props.breadcrumb=new BreadcrumbType()] - The breadcrumb data to be displayed.
 *
 * @returns {JSX.Element} The rendered breadcrumb navigation component.
 *
 * @example
 * const breadcrumbData = {
 *   crumbs: [
 *     { label: 'Home', link: '/dashboard', isActive: true },
 *     { label: 'Section', link: '/section', isActive: true },
 *     { label: 'Subsection', link: '', isActive: false }
 *   ]
 * };
 * 
 * <MyBreadcrumb breadcrumb={breadcrumbData} />
 */
export default function MyBreadcrumb({ breadcrumb = new BreadcrumbType()
}: MyBreadcrumbProps) {


  return (
    <Container
      as="nav"
      className="breadcrumb"
      maxW="container.lg"
      maxH={"container.xl"}
      role="navigation"
      display={"flex"}
      margin={"auto"}
      mb={1}
      p={0}
    >
      <Breadcrumb aria-label="breadcrumb" as={"nav"} fontWeight='medium' fontSize='xs'>
        <BreadcrumbItem>
          <BreadcrumbLink href="/dashboard" as={Link} to={"/dashboard"}>Home</BreadcrumbLink>
        </BreadcrumbItem>
        {breadcrumb.crumbs.map((crumb, index) => (
          <BreadcrumbItem
            isCurrentPage={index == breadcrumb.crumbs.length - 1 || !crumb.isActive}
            aria-current={index == breadcrumb.crumbs.length - 1 ? "page" : "false"}
          >
            <BreadcrumbLink
              style={{
                cursor: crumb.isActive ? "pointer" : "default",
              }}
              href={crumb.isActive ? crumb.link : ""} as={Link} to={crumb.isActive ? crumb.link : ""} >{crumb.label}</BreadcrumbLink>
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </Container>
  );
}
